import Main from './main.vue'
  export default Main


// WEBPACK FOOTER //
// ./src/components/global/PullToRefresh/index.js